/**
 * Size formatting for the KVM views.
 *
 * Everything the Prox API reports — plan memory (mem_mb × MiB), Proxmox maxmem /
 * maxdisk, netin/netout — is in binary units, and plans are sold in binary sizes.
 * The shared humanFileSize() defaults to decimal (÷1000), which turned a 16 GiB
 * plan into "17 GB" and a 120 GiB disk into "129 GB". This divides by 1024 but
 * keeps the familiar "GB" labels customers see on the plan.
 */
const UNITS = ['B', 'KB', 'MB', 'GB', 'TB', 'PB']

export function kvmSize (bytes) {
  if (bytes == null || isNaN(bytes)) return '—'
  let v = Math.abs(Number(bytes))
  let u = 0
  while (v >= 1024 && u < UNITS.length - 1) {
    v /= 1024
    u++
  }
  // One decimal for small values (3.2 GB), whole numbers otherwise (120 GB).
  const n = v < 10 && u > 0 ? Number(v.toFixed(1)) : Math.round(v)
  return `${bytes < 0 ? '-' : ''}${n} ${UNITS[u]}`
}
